<script>
  import ClickOut from '../../../../utils/directives/clickout'
  import Diarias from './policiacivil/configuracoes/Diarias'
  import Notificacao from './policiacivil/configuracoes/Notificacao'
  import Processo from './policiacivil/configuracoes/Processo'
  import Policiais from './policiacivil/configuracoes/Policiais'
  import Sistema from './policiacivil/configuracoes/Sistema'
  import Veiculo from './policiacivil/configuracoes/Veiculo'
  import AclCheckMixins from '../mixins/AclCheckMixins'
  import {GRV_APREENSAO_311} from '../../../../domain/grv/helpers/tipos-grv'

  export default{
    mixins: [AclCheckMixins],
    data () {
      return {
        open: false,
        GRV_APREENSAO_311,
        ID_CONTRATO_APREENSAO_311: 10
      }
    },
    computed: {
      podeAcessarMenusConfiguracao () {
        return this.possuiACL('acesso_menu_policia_civil_configuracoes')
      },
      podeAcessarApreensao311 () {
        const {id} = this.currentUser
        const possuiAcessoContratoApreensao311 = this.ACL.checaAcessoContrato(this.ID_CONTRATO_APREENSAO_311, id)

        return !this.isRestritoVisitante && possuiAcessoContratoApreensao311 && this.possuiACL('acesso_menu_apreensao_311')
      }
    },
    mounted () {
      this.popupItem = this.$el
    },
    methods: {
      toggle () {
        this.open = !this.open
      },
      hide () {
        this.open = false
      },
      clicked: function (e) {
        console.log('prevented!')
        e.preventDefault()
      }
    },
    components: {
      Diarias,
      Notificacao,
      Processo,
      Policiais,
      Sistema,
      Veiculo
    },
    directives: {ClickOut}
  }
</script>

<template>
  <li :class="{ active: open }">
    <a v-click-out="hide" @click="toggle" class="auto">
      <span class="pull-right text-muted">
      <i class="fa fa-fw fa-angle-right text"></i>
      <i class="fa fa-fw fa-angle-down text-active"></i>
      </span>
      <i class="icon-shield icon text-danger"></i>
      <span>Polícia Civil</span>
    </a>
    <ul class="nav nav-sub dk">
      <li class="nav-sub-header"><a><span class="text-muted teste">Polícia Civil</span></a></li>
      <!--<li>
        <router-link :to="{ name: 'config.cadastro-publico.list' }">
          <span>Cadastros públicos</span>
        </router-link>
      </li>-->
      <li>
        <router-link :to="{ name: 'roubo-furto.list' }">
          <span>Roubo/Furto</span>
        </router-link>
      </li>
      <li v-if="podeAcessarApreensao311">
        <router-link :to="{ name: 'grv', query: { tipoGrv: GRV_APREENSAO_311 } }">
          <span>Apreensão 311</span>
        </router-link>
      </li>
      <!--<li>
        <router-link :to="{ name: 'roubo-furto.list' }">
          <span>Salvados</span>
        </router-link>
      </li>-->

      <Diarias v-if="podeAcessarMenusConfiguracao"/>
      <Policiais v-if="podeAcessarMenusConfiguracao" />
      <Notificacao v-if="podeAcessarMenusConfiguracao" />
      <Processo v-if="podeAcessarMenusConfiguracao" />
      <Sistema v-if="podeAcessarMenusConfiguracao" />
      <Veiculo v-if="podeAcessarMenusConfiguracao" />
    </ul>
  </li>
</template>



// WEBPACK FOOTER //
// PoliciaCivil.vue?0f645f54